/* eslint-disable complexity */
/** 组操作记录变更列表 */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Drawer, Empty, Spin, Timeline, message } from "antd";
import IconFont from "@/components/icon";
import ChatState from "@/types/chat/State";
import { useTranslation } from "react-i18next";
import { connect } from "dvajs";
import "./index.less";
import dayjs from "dayjs";
import { isYearBefore } from "@/utils/date";
import { Avatar } from "@/baseComponents/Avatar";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { changeEgovUrl } from "@/utils/tools";
import bus from "@/utils/bus";
import { getGroupRecord } from "@/api/chat";
import OriginMember from "./OriginMember";
import noticeImg from "@/assets/img/empty/im-empty.png";
import ImService from "@/server/ImService";
import { getRole, isCardViewGroupSession, isEqualEmployee } from "@/utils/chat/message";
import { isGroupOrdinary } from "@/utils/chat/group";
import { UserCardPayload } from "@/models";
import Context from "@/components/chat/context";
import { tagsNode } from "@/components/AddressBook/common";
import { FocusSDK, isFocusEnv } from "@/utils";
import InfiniteScroll from "react-infinite-scroller";
import { groupBy } from "lodash";

function GroupRecord(props: any) {
  const { selectedSession, currentEmployee, toggleUserCardModal } = props;
  const groupId = selectedSession.sessionId;
  const { t } = useTranslation("chat");
  const [groupRecord, setGroupRecord] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [groupRecordVisible, setGroupRecordVisible] = useState(false);
  const { groupRosterIdentity } = React.useContext(Context);
  const [pageNum, setPageNum] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [allData, setAllData] = useState<any>([]);
  const [loadAll, setLoadAll] = useState(false);
  const pageSize = 50;
  const pageSize_export = 300;
  const onClose = () => {
    setGroupRecordVisible(false);
    setGroupRecord([]);
    setLoadAll(false);
    setAllData([]);
  };
  const titleNode = useMemo(() => {
    return (
      <div>
        <IconFont
          type="iconwin_left"
          className="group-management-icon-arrow app-region-none"
          onClick={onClose}
        />
        <span className="management-title">{t("group_change_record")}</span>
      </div>
    );
  }, [onClose, t]);

  const getList = useCallback(() => {
    setLoading(true);
    getGroupRecord({
      pageNo: pageNum,
      pageSize: pageSize,
      groupId: groupId
    }).then((res) => {
      if (res[0]) {
        const data: {
          pageCount: number;
          pageSize: number;
          list: any[];
        } = res[0];
        const hasMore = pageNum < data.pageCount;
        setHasMore(hasMore);
        dealData(data.list);
        if (hasMore) {
          setPageNum(pageNum + 1);
        }
      }
      setLoading(false);
    });
  }, [pageNum, loading]);

  async function dealData(data: any[], isExport?: boolean) {
    const operator = data.map((item: any) => {
      return {
        appId: item.operatorApp,
        teamId: item.operatorTeamId,
        userId: item.operatorId
      };
    });
    const user = data.map((item: any) => {
      return {
        appId: item.userApp || item.operatorApp,
        teamId: item.userTeamId || item.operatorTeamId,
        userId: item.userId || item.operatorId
      };
    });
    const param = [...operator, ...user];
    const noRepeat = [...new Set(param.map((item) => JSON.stringify(item)))];
    const filterUser = noRepeat.map((item) => JSON.parse(item));
    const memberInfo = await ImService.getInstance().getChangeUserDetailList(filterUser, true);
    const result = data.map((item: any) => {
      memberInfo.forEach((member: any) => {
        if (
          member.userId === item.userId &&
          member.teamId === item.userTeamId &&
          member.app === item.userApp
        ) {
          item = Object.assign(item, member);
        }
        if (
          member.userId === item.operatorId &&
          member.teamId === item.operatorTeamId &&
          member.app === item.operatorApp
        ) {
          if (item.operateType === 0) {
            item = Object.assign(item, member);
          }
          item = Object.assign(item, {
            operatorName: member.name,
            operatorAvatar: member.avatar,
            operatorUnitName: member.unitName
          });
        }
      });
      return item;
    });
    if (isExport) {
      const loadLen = Math.floor(groupRecord.flat().length / pageSize_export) * pageSize_export;
      const isLoaded = groupRecord.flat().slice(0, loadLen);
      setAllData([...isLoaded, ...result]);
      dealRecord([...isLoaded, ...result]);
      return;
    }
    // 时间相同的聚合
    let dealRes: any[] = [];
    result.map((item: any, index: any) => {
      if (index === 0 || item?.gmtCreate !== result[index - 1]?.gmtCreate) {
        dealRes.push([item]);
      } else {
        dealRes[dealRes.length - 1].push(item);
      }
    });
    setGroupRecord((prev: any) => [...prev, ...dealRes]);
  }

  const openUserCard = (data: any, type?: string) => {
    let info: any;
    if (type === "operator") {
      info = {
        userId: data.operatorId,
        teamId: data.operatorTeamId,
        app: data.operatorApp
      };
    } else {
      info = {
        userId: data.userId,
        teamId: data.teamId,
        app: data.app
      };
    }
    // 如果群成员并且禁止了查看群成员名片
    if (
      !isEqualEmployee(currentEmployee, info) &&
      isGroupOrdinary(groupRosterIdentity) &&
      !isCardViewGroupSession(selectedSession)
    ) {
      message.warn(t("can_not_open_user_card_tip"));
      return false;
    }

    toggleUserCardModal({
      visible: true,
      userId: info.userId,
      teamId: info.teamId,
      appId: info.app
    });
  };

  useEffect(() => {
    bus.on("record:open", (res) => {
      if (res === true) {
        getList();
        setGroupRecordVisible(true);
      }
    });
    return () => {
      bus.off("record:open");
    };
  }, []);

  const getAvatar = (name: string, avatar: string) => {
    return (
      <Avatar
        styleObj={{
          width: "40px",
          height: "40px"
        }}
        src={avatar ? changeEgovUrl(getHeadImgThumbUrl(avatar, 150, 150)) : ""}
        className="avatarNoDraggable"
        name={name}
      />
    );
  };

  const tagClass = (type: string) => {
    return `change-tag change-tag-${type}`;
  };

  // 0、组创建 1、组创建人变更 2、组管理员变更 3、组成员增加 4、组成员减少
  const getTag = (type: number, isExport?: boolean) => {
    switch (type) {
      case 0:
        if (isExport) {
          return t("group_change_tag.create");
        }
        return <span className={tagClass("create")}>{t("group_change_tag.create")}</span>;
      case 1:
        if (isExport) {
          return t("group_change_tag.owner");
        }
        return <span className={tagClass("create")}>{t("group_change_tag.owner")}</span>;
      case 2:
        if (isExport) {
          return t("group_change_tag.admin");
        }
        return <span className={tagClass("create")}>{t("group_change_tag.admin")}</span>;
      case 3:
        if (isExport) {
          return t("group_change_tag.add");
        }
        return <span className={tagClass("add")}>{t("group_change_tag.add")}</span>;
      case 4:
        if (isExport) {
          return t("group_change_tag.remove");
        }
        return <span className={tagClass("remove")}>{t("group_change_tag.remove")}</span>;
    }
  };

  const detailOpen = () => {
    bus.emit("originNum:open", true);
    return;
  };

  const formatDate = (time: number) => {
    return dayjs(time).format(
      `${isYearBefore(time) ? "YYYY年M月D日 HH:mm:ss" : "M月D日 HH:mm:ss"}`
    );
  };

  // 0、创建，1、转让组创建人，2、删除被动转创建人，3、添加管理员，4、群主/管理员主动删除管理员，5、扫码入组，6、邀请入组，7、主动退组，8、被移出组，9、后台删除
  const operateDesc = (item: any, isExport?: boolean) => {
    const operator = item.operatorName && !isExport ? `@${item.operatorName}` : item.operatorName;
    const type = item.operateType;
    switch (type) {
      case 0:
        if (isExport) {
          return `创建群，并添加${item.initUserNumber}位初始群成员`;
        }
        return (
          <div className="list-body-operate">
            创建群，并添加
            <span className="desc_highlight" onClick={detailOpen}>
              {item.initUserNumber}位初始群成员
            </span>
          </div>
        );
      case 1:
        if (isExport) {
          return `由${operator}转让群创建人`;
        }
        return (
          <div className="list-body-operate">
            由
            <span
              className="desc_highlight"
              onClick={() => {
                openUserCard(item, "operator");
              }}
            >
              {operator}
            </span>
            转让为群创建人
          </div>
        );
      case 2:
        if (isExport) {
          return "由系统转让为群创建人";
        }
        return <div className="list-body-operate">由系统转让为群创建人</div>;
      case 3:
        if (isExport) {
          return `由${operator}添加为群管理员`;
        }
        return (
          <div className="list-body-operate">
            由
            <span
              className="desc_highlight"
              onClick={() => {
                openUserCard(item, "operator");
              }}
            >
              {operator}
            </span>
            添加为群管理员
          </div>
        );
      case 4:
        if (isExport) {
          return `由${operator}移除群管理员`;
        }
        return (
          <div className="list-body-operate">
            由
            <span
              className="desc_highlight"
              onClick={() => {
                openUserCard(item, "operator");
              }}
            >
              {operator}
            </span>
            移除群管理员
          </div>
        );
      case 5:
        if (isExport) {
          return "通过扫码入群";
        }
        return <div className="list-body-operate">通过扫码入群</div>;
      case 6:
        if (isExport) {
          return `由${operator}邀请入群`;
        }
        return (
          <div className="list-body-operate">
            由
            <span
              className="desc_highlight"
              onClick={() => {
                openUserCard(item, "operator");
              }}
            >
              {operator}
            </span>
            邀请入群
          </div>
        );
      case 7:
        if (isExport) {
          return "退出群";
        }
        return <div className="list-body-operate">退出群</div>;
      case 8:
        if (isExport) {
          return `由${operator}移出群`;
        }
        return (
          <div className="list-body-operate">
            由
            <span
              className="desc_highlight"
              onClick={() => {
                openUserCard(item, "operator");
              }}
            >
              {operator}
            </span>
            移出群
          </div>
        );
      case 9:
        if (isExport) {
          return "账号已被删除";
        }
        return <div className="list-body-operate">账号已被删除</div>;
      case 10:
        if (isExport) {
          return `通过日程邀请入群`;
        }
        return <div className="list-body-operate">通过日程邀请入群</div>;
    }
  };

  const recordList = groupRecord.map((item: any, index: any) => {
    return (
      <div className="list-container" key={index}>
        <div className="list-head">{formatDate(item[0].gmtCreate)}</div>
        {item.map((item: any) => {
          return (
            <div className="list-body">
              <div
                className="list-body-avatar"
                onClick={() => {
                  openUserCard(item);
                }}
              >
                {item.operateType === 0
                  ? getAvatar(item.operatorName, item.operatorAvatar)
                  : getAvatar(item.name, item.avatar)}
              </div>
              <div className="list-body-desc">
                <div className="list-body-info">
                  <div className="info-name">{item.name}</div>
                  {tagsNode(item.labelInfoList)}
                  <div className="info-unit">{item.unitName ? `@${item.unitName}` : null}</div>
                </div>
                {operateDesc(item)}
              </div>
              {getTag(item.changeType)}
            </div>
          );
        })}
      </div>
    );
  });
  const dealMember = () => {
    const data = [["姓名", "角色", "单位", "部门", "职务"]];
    const members = Object.values((selectedSession.info as any).rosters || []);
    const groups = groupBy(members, "identity");
    let result: any[] = [];
    if (groups?.administrator) {
      result.push(...groups.administrator);
    }
    if (groups?.sub_administrator) {
      result.push(...groups.sub_administrator);
    }
    if (groups?.ordinary) {
      result.push(...groups.ordinary);
    }
    result.map((roster: any) => {
      data.push([
        roster.info.name,
        getRole(roster.identity),
        roster.info.unitName,
        roster.info.deptName,
        roster.info.titleName
      ]);
    });
    FocusSDK.sendIpcMessage(
      "focus:im:group:export-data",
      JSON.stringify({
        data: data,
        fileType: "excel",
        fileName: "导出成员信息"
      })
    );
  };

  let restData: any[] = [];

  async function getRestData(pageNo: number) {
    const [data, error] = await getGroupRecord({
      pageNo: pageNo,
      pageSize: pageSize_export,
      groupId: groupId
    });
    setLoading(false);
    restData.push(...data.list);
    if (pageNo < data.pageCount) {
      await getRestData(pageNo + 1);
    } else {
      setLoadAll(true);
      dealData(restData, true);
    }
  }

  const dealRecord = (allRes: any) => {
    const data = [["人员", "时间", "操作信息", "场景"]];
    allRes.reverse().map((record: any) => {
      data.push([
        record.name,
        formatDate(record.gmtCreate),
        operateDesc(record, true),
        getTag(record.changeType, true)
      ]);
    });
    FocusSDK.sendIpcMessage(
      "focus:im:group:export-data",
      JSON.stringify({
        data: data,
        fileType: "excel",
        fileName: "导出群变更记录"
      })
    );
    return data;
  };

  const handleExport = useCallback(
    async (type: string) => {
      if (type === "member") {
        dealMember();
      } else {
        if (!groupRecord.length) {
          return;
        }
        if (!hasMore) {
          dealRecord(groupRecord.flat());
          return;
        } else if (loadAll) {
          dealRecord(allData);
          return;
        } else {
          const pageNo = Math.floor(groupRecord.flat().length / pageSize_export) + 1;
          await getRestData(pageNo);
        }
      }
    },
    [allData, dealMember, dealRecord, getRestData, groupRecord, hasMore, loadAll]
  );

  const exportData = () => {
    if (!isFocusEnv()) {
      return;
    }
    return (
      <div className="export-btn">
        {/* <div className="btn-operate" onClick={() => handleExport("member")}>
          导出成员信息
        </div> */}
        <div
          className="btn-operate"
          onClick={() => handleExport("record")}
          style={groupRecord.length ? {} : { opacity: "0.5", cursor: "not-allowed" }}
        >
          导出变更记录
        </div>
      </div>
    );
  };

  return (
    <>
      <Drawer
        className="group-record-drawer"
        title={titleNode}
        placement="right"
        width="375px"
        height="100%"
        mask={false}
        destroyOnClose={true}
        closable={false}
        onClose={onClose}
        visible={groupRecordVisible}
        style={{ position: "absolute", right: 0 }}
        footer={exportData()}
      >
        {loading && (
          <div className="loading">
            <Spin spinning={loading} />
          </div>
        )}
        {!loading && !groupRecord.length && (
          <Empty
            image={noticeImg}
            imageStyle={{
              width: 120,
              height: 120
            }}
            description={<span>暂无群变更内容</span>}
          />
        )}
        {groupRecord.length > 0 && (
          <div className="record-list">
            <InfiniteScroll
              pageStart={0}
              initialLoad={false}
              loadMore={() => {
                getList();
              }}
              hasMore={!loading && hasMore}
              useWindow={false}
            >
              <Timeline className="time-line-container">
                {recordList.map((item: any, index: number) => (
                  <Timeline.Item key={index}>{item}</Timeline.Item>
                ))}
              </Timeline>
            </InfiniteScroll>
          </div>
        )}
      </Drawer>
      <OriginMember />
    </>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, currentEmployee } = chat as ChatState;
  return {
    selectedSession,
    currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    toggleUserCardModal(payload: UserCardPayload) {
      dispatch({ type: "app/toggleUserCardModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupRecord);
